var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-notice-list" },
    _vm._l(_vm.latestOrders, function(order, index) {
      return _c("notice", {
        key: index,
        attrs: {
          type: order.type,
          title: order.title,
          close: order.close,
          rawData: order,
          describe: order.describe
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }